export const ANALYTICS_JLDATA_UPDATED = "JlDataUpdateComplete";
export const CITRUS_AD_CLICK = "citrusAd.clicked";
export const GLOBAL_INTERACTION = "global.interaction";
export const JL_EVENTS_ADD_TO_BASKET_CLICK =
  "jl-events.browser.addToBasketClick";
export const JL_EVENTS_ADD_TO_BASKET_ERROR =
  "jl-events.browser.addToBasketError";
export const JL_EVENTS_ADD_TO_BASKET_SUCCESS =
  "jl-events.browser.addToBasketSuccess";
export const JL_EVENTS_BASKET_QUANTITY_UPDATED =
  "jl-events.browser.basketQuantityUpdated";
export const JL_EVENTS_EMAILME_CLOSE = "jl-events.browser.closeEmailMeModal";
export const JL_EVENTS_WISHLIST_QUANTITY_UPDATED =
  "jl-events.browser.wishlistQuantityUpdated";
export const KEVEL_AD_CLICK = "kevel.clicked";
export const KEVEL_AD_IMPRESSION = "kevel.impression";
export const VIEW_GIFT_MESSAGES = "product-list.gift-messages.show";
export const WISHLIST_ADD_TO_BASKET = "product-list.wishlist.add-to-basket";
export const WISHLIST_GIFT_MESSAGE = "product-list.wishlist.gift-message";
export const WISHLIST_GIFT_MESSAGE_ERROR = "jl-events.browser.giftMessageError";
export const WISHLIST_GIFT_MESSAGE_SUCCESS =
  "jl-events.browser.giftMessageSuccess";
